module.exports = __webpack_public_path__ + "img/case16.09bfaf17.png";